<div class="add-course-container">
  <div class="top-section">
    <div class="title">
      <div class="main-title">
        {{ isUpdate ? 'Update Course' : 'Add a New Course' }}
      </div>
    </div>

    <div class="close-btn" (click)="onClickCancel()">
      <i class="fa-solid fa-xmark"></i>
    </div>
  </div>

  <form class="form-section" [formGroup]="courseForm">
    <div class="left-section">
      <input formControlName="title" autocomplete="off" placeholder="Title" />

      <input formControlName="duration" autocomplete="off" placeholder="Course Duration" />

      <select formControlName="category">
        <option value="" disabled>Select a category</option>
        <option *ngFor="let category of courseCategories" [value]="category">
          {{ category }}
        </option>
      </select>

      <textarea rows="8" formControlName="prerequisite"
        placeholder='Prerequisite knowledge. Separate multiple requirements using "."'></textarea>

      <textarea rows="8" formControlName="toWhom"
        placeholder='Who this course is for. Separate multiple items using "."'></textarea>
    </div>

    <div class="right-section">
      <textarea rows="8" formControlName="description" placeholder="Detailed course description"></textarea>

      <input id="file-input" type="file" accept=".jpg,.jpeg,.png" (change)="onFileUpload($event)" />

      <label for="file-input">
        <span class="text">Upload a thumbnail</span>
        <span class="file-text">{{ fileName }}</span>
      </label>

      <input formControlName="price" autocomplete="off" placeholder="Price" />

      <textarea rows="8" formControlName="toLearn"
        placeholder='What you will learn. Separate multiple learnings using "."'></textarea>
    </div>
  </form>

  <div class="btn-section">
    <button type="button" [disabled]="isLoading" (click)="isUpdate ? onUpdateCourse() : onCreateCourse()">
      {{ isLoading ? (isUpdate ? 'Updating' : 'Creating') : (isUpdate ?
      'Update Course' : 'Create Course') }}

      <i *ngIf="isLoading" class="fa-solid fa-spinner fa-spin"></i>
    </button>
  </div>
</div>